// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Filters — sidebar accordion sections with checkboxes
   ============================================ */

.grb-widget--filters {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

/* Scrollable sections area */
.grb-widget--filter-sections {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* Accordion section */
.grb-widget--filter-section {
  border-bottom: 1px solid var(--grb-color-border);
}

.grb-widget--filter-section:last-of-type {
  border-bottom: none;
}

/* Accordion header */
.grb-widget--filter-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 14px var(--grb-spacing-md);
  font-size: var(--grb-font-size-base);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  cursor: pointer;
  transition: background-color 0.15s ease;
  text-align: left;
}

.grb-widget--filter-header:hover {
  background-color: var(--grb-color-background-secondary);
}

/* Chevron icon */
.grb-widget--filter-chevron {
  width: 10px;
  height: 10px;
  border-right: 1.5px solid var(--grb-color-text);
  border-bottom: 1.5px solid var(--grb-color-text);
  transform: rotate(45deg);
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.grb-widget--filter-section.grb-widget--open .grb-widget--filter-chevron {
  transform: rotate(-135deg);
}

/* Accordion body — animated via max-height */
.grb-widget--filter-body {
  max-height: 0;
  overflow: hidden;
  padding: 0 var(--grb-spacing-md);
  transition: max-height 0.25s ease, padding 0.25s ease;
}

.grb-widget--filter-section.grb-widget--open .grb-widget--filter-body {
  padding: 0 var(--grb-spacing-md) var(--grb-spacing-md);
}

/* Checkbox items */
.grb-widget--filter-item {
  display: flex;
  align-items: center;
  gap: var(--grb-spacing-sm);
  padding: 6px 0;
  cursor: pointer;
  font-size: var(--grb-font-size-base);
  transition: color 0.15s ease;
}

.grb-widget--filter-item:hover {
  color: var(--grb-color-text-secondary);
}

.grb-widget--filter-item-label {
  flex: 1;
  user-select: none;
}

.grb-widget--filter-item-count {
  font-size: var(--grb-font-size-xs);
  color: var(--grb-color-text-secondary);
}

/* Color swatch in filter item */
.grb-widget--filter-color-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid var(--grb-color-border);
  flex-shrink: 0;
}

/* Price range inputs */
.grb-widget--price-inputs {
  display: flex;
  align-items: center;
  gap: var(--grb-spacing-sm);
  padding-top: var(--grb-spacing-xs);
}

.grb-widget--price-input {
  flex: 1;
  height: 36px;
  padding: 0 var(--grb-spacing-sm);
  border: 1px solid var(--grb-color-border);
  font-size: var(--grb-font-size-base);
  text-align: center;
  background: var(--grb-color-background);
}

.grb-widget--price-input:focus {
  border-color: var(--grb-color-primary);
}

.grb-widget--price-separator {
  color: var(--grb-color-text-secondary);
  font-size: var(--grb-font-size-sm);
  flex-shrink: 0;
}

/* Action buttons — fixed at bottom of sidebar */
.grb-widget--filter-actions {
  padding: var(--grb-spacing-md);
  display: flex;
  flex-direction: row;
  gap: var(--grb-spacing-sm);
  border-top: 1px solid var(--grb-color-border);
  flex-shrink: 0;
}

.grb-widget .grb-widget--filter-apply-btn {
  flex: 1;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--grb-color-primary);
  color: #fff;
  font-size: var(--grb-font-size-sm);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  transition: background-color 0.15s ease;
}

.grb-widget .grb-widget--filter-apply-btn:hover {
  background: var(--grb-color-primary-hover);
}

.grb-widget .grb-widget--filter-clear-btn {
  flex: 1;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--grb-color-border);
  background: transparent;
  font-size: var(--grb-font-size-sm);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--grb-color-text);
  transition: all 0.15s ease;
}

.grb-widget .grb-widget--filter-clear-btn:hover {
  background: var(--grb-color-background-secondary);
}

/* Mobile: filter toggle button */
.grb-widget--filter-toggle {
  display: none;
  align-items: center;
  justify-content: center;
  gap: var(--grb-spacing-sm);
  height: 40px;
  padding: 0 var(--grb-spacing-md);
  border: 1px solid var(--grb-color-border);
  font-size: var(--grb-font-size-sm);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin: var(--grb-spacing-sm) var(--grb-spacing-md);
}

@media (max-width: 768px) {
  .grb-widget--filter-toggle {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/filters.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,OAAO;EACP,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mCAAmC;EACnC,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;AACzD;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,gDAAgD;EAChD,wBAAwB;EACxB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,qDAAqD;AACvD;;AAEA;EACE,sDAAsD;AACxD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gCAAgC;EAChC,yCAAyC;EACzC,oCAAoC;EACpC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,WAAW;EACX,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,iDAAiD;AACnD;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,YAAY;EACZ,gCAAgC;EAChC,yCAAyC;EACzC,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* ============================================\n   Filters — sidebar accordion sections with checkboxes\n   ============================================ */\n\n.grb-widget--filters {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* Scrollable sections area */\n.grb-widget--filter-sections {\n  flex: 1;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Accordion section */\n.grb-widget--filter-section {\n  border-bottom: 1px solid var(--grb-color-border);\n}\n\n.grb-widget--filter-section:last-of-type {\n  border-bottom: none;\n}\n\n/* Accordion header */\n.grb-widget--filter-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 14px var(--grb-spacing-md);\n  font-size: var(--grb-font-size-base);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n  text-align: left;\n}\n\n.grb-widget--filter-header:hover {\n  background-color: var(--grb-color-background-secondary);\n}\n\n/* Chevron icon */\n.grb-widget--filter-chevron {\n  width: 10px;\n  height: 10px;\n  border-right: 1.5px solid var(--grb-color-text);\n  border-bottom: 1.5px solid var(--grb-color-text);\n  transform: rotate(45deg);\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.grb-widget--filter-section.grb-widget--open .grb-widget--filter-chevron {\n  transform: rotate(-135deg);\n}\n\n/* Accordion body — animated via max-height */\n.grb-widget--filter-body {\n  max-height: 0;\n  overflow: hidden;\n  padding: 0 var(--grb-spacing-md);\n  transition: max-height 0.25s ease, padding 0.25s ease;\n}\n\n.grb-widget--filter-section.grb-widget--open .grb-widget--filter-body {\n  padding: 0 var(--grb-spacing-md) var(--grb-spacing-md);\n}\n\n/* Checkbox items */\n.grb-widget--filter-item {\n  display: flex;\n  align-items: center;\n  gap: var(--grb-spacing-sm);\n  padding: 6px 0;\n  cursor: pointer;\n  font-size: var(--grb-font-size-base);\n  transition: color 0.15s ease;\n}\n\n.grb-widget--filter-item:hover {\n  color: var(--grb-color-text-secondary);\n}\n\n.grb-widget--filter-item-label {\n  flex: 1;\n  user-select: none;\n}\n\n.grb-widget--filter-item-count {\n  font-size: var(--grb-font-size-xs);\n  color: var(--grb-color-text-secondary);\n}\n\n/* Color swatch in filter item */\n.grb-widget--filter-color-dot {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 1px solid var(--grb-color-border);\n  flex-shrink: 0;\n}\n\n/* Price range inputs */\n.grb-widget--price-inputs {\n  display: flex;\n  align-items: center;\n  gap: var(--grb-spacing-sm);\n  padding-top: var(--grb-spacing-xs);\n}\n\n.grb-widget--price-input {\n  flex: 1;\n  height: 36px;\n  padding: 0 var(--grb-spacing-sm);\n  border: 1px solid var(--grb-color-border);\n  font-size: var(--grb-font-size-base);\n  text-align: center;\n  background: var(--grb-color-background);\n}\n\n.grb-widget--price-input:focus {\n  border-color: var(--grb-color-primary);\n}\n\n.grb-widget--price-separator {\n  color: var(--grb-color-text-secondary);\n  font-size: var(--grb-font-size-sm);\n  flex-shrink: 0;\n}\n\n/* Action buttons — fixed at bottom of sidebar */\n.grb-widget--filter-actions {\n  padding: var(--grb-spacing-md);\n  display: flex;\n  flex-direction: row;\n  gap: var(--grb-spacing-sm);\n  border-top: 1px solid var(--grb-color-border);\n  flex-shrink: 0;\n}\n\n.grb-widget .grb-widget--filter-apply-btn {\n  flex: 1;\n  height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--grb-color-primary);\n  color: #fff;\n  font-size: var(--grb-font-size-sm);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  transition: background-color 0.15s ease;\n}\n\n.grb-widget .grb-widget--filter-apply-btn:hover {\n  background: var(--grb-color-primary-hover);\n}\n\n.grb-widget .grb-widget--filter-clear-btn {\n  flex: 1;\n  height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--grb-color-border);\n  background: transparent;\n  font-size: var(--grb-font-size-sm);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--grb-color-text);\n  transition: all 0.15s ease;\n}\n\n.grb-widget .grb-widget--filter-clear-btn:hover {\n  background: var(--grb-color-background-secondary);\n}\n\n/* Mobile: filter toggle button */\n.grb-widget--filter-toggle {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  gap: var(--grb-spacing-sm);\n  height: 40px;\n  padding: 0 var(--grb-spacing-md);\n  border: 1px solid var(--grb-color-border);\n  font-size: var(--grb-font-size-sm);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin: var(--grb-spacing-sm) var(--grb-spacing-md);\n}\n\n@media (max-width: 768px) {\n  .grb-widget--filter-toggle {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
